import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'
import { SansText } from '@velasca/ui/sans-text'

export const Background = styled.li`
  background: ${({ theme }) => theme.colors.modalBackground};
  width: 100%;
`

export const Card = styled.div`
  padding: 0 2rem 0 0;
  display: flex;
  gap: 2rem;
  justify-content: flex-start;
  position: relative;
`

export const ImageWrapper = styled.div`
  height: 15rem;
  aspect-ratio: 4/5;
`

export const LoadingImage = styled(Skeleton)`
  height: 100%;
  display: block;
`

export const LoadingButton = styled.div`
  padding: 1.1rem 2.2rem;
  display: flex;
  align-items: center;
`

export const ProductImage = styled(ResponsiveImage)`
  height: 100%;
  object-fit: cover;
`

export const Details = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0;
  flex-grow: 1;

  .product-type {
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.text.light};
    font-weight: 500;
    font-size: 1.2rem;
  }
`

export const Spacer = styled.div`
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0;

  .bold {
    font-weight: 500;
  }
`

export const Separator = styled.hr`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin: 0;
`

export const Button = styled.button`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 1rem 1.2rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  border: none;
  background: ${({ theme }) => theme.colors.modalBackground};

  &:disabled {
    background: ${({ theme }) => theme.colors.disabled};
    pointer-events: none;

    ${SansText} {
      color: ${({ theme }) => theme.colors.text.light};
    }
  }

  &:active {
    background: ${({ theme }) => theme.colors.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`
